import { createApp } from '@app/adapters/create-app'

import InboxUnreadCount from '../../screens/inbox/components/inbox-unread-count.vue'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='inbox-unread-count']").each(function () {
    const dataUrl = this.getAttribute('data-url')
    const rawInitialCount = this.getAttribute('data-initial-count')
    const initialCount =
      rawInitialCount !== null ? parseInt(rawInitialCount, 10) : null
    createApp(InboxUnreadCount, {
      url: dataUrl,
      className: this.getAttribute('data-class'),
      initialCount,
    }).mount(this)
  })
})
